<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import ReceitasTable from './receitas-table'
import appConfig from "@/app.config";
import Swal from "sweetalert2";

import { receitasChart1, receitasChart2 } from "../components/data-simulados";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Receitas",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, ReceitasTable, Loader },
  methods: {
    alterouReg() {
      console.log('alterouReg_pai')
      this.updating = true
      setTimeout(() => {
        console.log('timeOut')
        this.updating = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        });

      }, 1000)
    },

    criarNovo() {
      console.log('criarNovo')
      this.updating = !this.updating
    }
  },
  mounted() {
    console.log('mounted receitas-list_0')
    // eslint-disable-next-line no-unused-vars
    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      this.updating = false

      this.dataList = [
        {
          id: '#SK99005',
          descricao: 'Fornecedor Testes 000777',
          date: '07 Abr, 2023',
          cidade: 'Serra',
          estado: 'ES',
          telefone: '',
          email: 'admin@dominio.com.br',
          total: '400.890,00',
          status: 'Quitado',
          tags: ['5 Orçamentos', '5 Pedidos'],
          index: 1,
        },
        {
          id: '#SK99088',
          image: require('@/assets/images/users/avatar-1.jpg'),
          descricao: 'Fornecedor Testes 000787',
          date: '07 Abr, 2023',
          cidade: 'Vila Velha',
          estado: 'ES',
          telefone: '00.0.0000-0000',
          email: 'repres@dominio.com.br',
          total: '955.677,14',
          status: 'Cancelado',
          tags: ['1 Pedido'],
          index: 2,
        },
        {
          id: '#SK99001',
          image: require('@/assets/images/users/avatar-2.jpg'),
          descricao: 'Fornecedor Testes 000004',
          date: '06 Abr, 2023',
          cidade: 'Vitória',
          estado: 'ES',
          telefone: '00.0.0000-0000',
          email: 'mkt@dominio.com.br',
          total: '8.900,00',
          status: 'Quitado',
          tags: ['2 Orçamentos'],
          index: 3,
        },
        {
          id: '#SK58000',
          image: require('@/assets/images/users/avatar-3.jpg'),
          descricao: 'Fornecedor Testes 000777',
          date: '05 Abr, 2023',
          cidade: 'Vitória',
          estado: 'ES',
          telefone: '00.0.0000-0000',
          email: 'financeiro@dominio.com.br',
          total: '8.798.000,00',
          status: 'Quitado',
          tags: ['1 Novo Cliente'],
          index: 4,
        },
        {
          id: '#SK59000',
          image: require('@/assets/images/users/avatar-4.jpg'),
          descricao: 'Fornecedor Testes 000999',
          date: '04 Abr, 2023',
          cidade: 'Vitória',
          estado: 'ES',
          telefone: '00.0.0000-0000',
          email: 'superv@dominio.com.br',
          total: '3.200,00',
          status: 'Análise',
          tags: ['10 Pedidos'],
          index: 5,
        },
        {
          id: '#SK44800',
          image: require('@/assets/images/users/avatar-5.jpg'),
          descricao: 'Fornecedor Testes 000005',
          date: '04 Abr, 2023',
          cidade: 'Serra',
          estado: 'ES',
          telefone: '00.0.0000-0000',
          email: 'gerencia@dominio.com.br',
          total: '999,99',
          status: 'Quitado',
          tags: ['10 Orçamentos'],
          index: 6,
        },

      ]
    });
  },
  data() {
    return {
      title: 'Receitas',
      items: [
        {
          text: 'Financeiro',
          href: '/',
        },
        {
          text: 'Receitas',
          active: true,
        },
      ],
      updating: true,
      dataList: null,

      receiChart1: receitasChart1,
      receiChart2: receitasChart2,


    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input id="inputPesquisa"
                           type="text"
                           class="form-control"
                           placeholder="Enter para pesquisar..." />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select id="selectStatus"
                            class="form-control select2-search-disable">
                      <option value="BTC" selected>Todos</option>
                      <option value="ETH">Quitados</option>
                      <option value="LTC">Cancelados</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>


              <!--              <div class="col-sm-8">-->
              <!--                <div class="text-sm-end">-->

              <!--                  <button>-->
              <!--                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >-->
              <!--                      <i class="mdi mdi-plus me-1"></i> Novo Usuário-->
              <!--                    </button>-->
              <!--                  </button>-->

              <!--                </div>-->
              <!--              </div>-->

            </div>

            <Loader v-if="updating" style="min-height: 400px;">
            </Loader>

            <ReceitasTable v-if="!updating"
                           :dataList="dataList"
                           @alterareg="alterouReg"/>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">2</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">3</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">4</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">5</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>

    <div class="row" v-if="!updating">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Evolução Mensal</h4>
            <apexchart class="apex-charts"
                       type="area"
                       height="370"
                       :series="receiChart1.series"
                       :options="receiChart1.chartOptions">
            </apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Destaque Semana</h4>
            <apexchart class="apex-charts"
                       height="370"
                       type="pie"
                       dir="ltr"
                       :series="receiChart2.series"
                       :options="receiChart2.chartOptions">
            </apexchart>
          </div>
        </div>
      </div>


    </div>


  </Layout>
</template>
